import type SaveViewDialogStore from './schema/SaveViewDialogStore';
import { createStore } from 'satcheljs';

const initialSaveViewDialogStore: SaveViewDialogStore = {
    saveViewDialogShown: false,
    currentlyEditedView: null,
    charmId: null,
    viewName: '',
    isErrorState: false,
};

export let getStore = createStore<SaveViewDialogStore>(
    'SaveViewDialogStore',
    initialSaveViewDialogStore
);
